import { render, staticRenderFns } from "./AddWarehouse.vue?vue&type=template&id=73ad71eb&"
import script from "./AddWarehouse.vue?vue&type=script&lang=js&"
export * from "./AddWarehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports